import React from "react";

export const Testimonials = (props) => {
  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <h2>What our clients say</h2>
          <p>
            Here are some testimonials from our satisfied clients.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <div className="testimonial">
                    <div className="testimonial-image">
                      {" "}
                      <img src={d.img} alt="" />{" "}
                    </div>
                    <div className="testimonial-content">
                      <p>"{d.text}"</p>
                      
                      {/* Cuma nambahin d.company di bagian ini ya */}
                      <div className="testimonial-meta"> 
                        - {d.name} <br />
                        <span style={{ fontSize: "13px", color: "#888", fontWeight: "normal" }}>
                          {d.company}
                        </span>
                      </div>
                      
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};